import { gql } from "@apollo/client";

export const GET_USER_PRODUCT_PREFERENCES = gql`
  query GetUserProductPreferences($where: ProductPreferencesWhereInput) {
    getUserProductPreferences(where: $where) {
      id
      shadeType
      productPreferenceType
      fixedProsthesisPreferences {
        itemType
        occlusalContactTightness
        proximalContactTightness
        noOcclusalClearance
        occlusalStaining
        interproximalContactDesign
        anteriorPosteriorPonticDesign
      }
      removableProsthesisPreferences {
        itemType
        splintHardness
        teethShape
      }
    }
  }
`;

export const GET_ALL_PROVIDERS = gql`
  query GetAllProviders {
    getAllProviders {
      id
      name
      displayPriority
    }
  }
`;

export const GET_USER_AND_ACCOUNT_PRODUCT_PREFERENCES = gql`
  query GetAccountProductPreferences {
    getAccountProductPreferences {
      id
      shadeType
      productPreferenceType
      dentist {
        id
        firstName
        lastName
      }
      fixedProsthesisPreferences {
        id
        itemType
        occlusalContactTightness
        proximalContactTightness
        noOcclusalClearance
        occlusalStaining
        interproximalContactDesign
        anteriorPosteriorPonticDesign
      }
      removableProsthesisPreferences {
        id
        itemType
        splintHardness
        teethShape
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query GetAllGroups(
    $skip: Int
    $take: Int
    $where: UserWhereInput
    $orderBy: [UserOrderByWithRelationInput!]
  ) {
    users(skip: $skip, take: $take, where: $where, orderBy: $orderBy) {
      id
      lastName
      firstName
      email
      isManager
    }
  }
`;

export const GET_USER = gql`
  query User($where: UserWhereUniqueInput!) {
    user(where: $where) {
      id
      isManager
      clientBilling {
        id
        pricingType
      }
      email
      firstName
      lastName
      role
      type
      phoneNumber
      communicateAccount
      meditAccount
      shining3dAccount
      dsCoreAccount
      userGroup {
        id
        name
        clinicNumber
        clientBilling {
          id
          pricingType
        }
        addresses {
          id
          city
          country
          name
          postcode
          streetName
          details
          streetNumber
        }
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($args: UserCreateInput!) {
    createUser(args: $args) {
      id
    }
  }
`;

export const GET_PRACTITIONERS_FROM_USER_GROUP = gql`
  query getManagedUserGroupOfUser {
    getManagedUserGroupOfUser {
      id
      clinicNumber
      groupMembers {
        id
        firstName
        lastName
        isManager
      }
    }
  }
`;

export const GET_ALL_PRACTITIONERS = gql`
  query GetManyUsersDocument($where: UserWhereInput) {
    getManyUsers(where: $where) {
      id
      firstName
      lastName
      isManager
      userGroup {
        id
        clinicNumber
        groupMembers {
          id
        }
      }
    }
  }
`;
